export default __webpack_public_path__ + "static/selfapp-screens-mobile-eb96ee339ff1d00c1a12c265b1902149.jpg";